/* eslint-disable @next/next/no-img-element */
import { PublicProfile } from "@dimensional-engineering/dimensional-models";
import Link from "next/link";
import styles from "./TraitsFooter.module.css";

type FootersProps = {
  connectionList?: PublicProfile[];
};

export default function TraitsFooter(props: FootersProps) {
  return (
    <>
      <footer className={styles.footerMain}>
        <div className={styles.parent}>
          {!props.connectionList ? (
            <ul className={styles.footerChild}>
              <li className={styles.footerChildHeader}>About</li>
              <Link href={"https://about.dimensional.me/personality-test"}>
                <li className={styles.footerChildListItem}>Personality Test</li>
              </Link>
              <Link href={"https://about.dimensional.me/about"}>
                <li className={styles.footerChildListItem}>
                  About Dimensional
                </li>
              </Link>
              <Link href={"https://about.dimensional.me/"}>
                <li className={styles.footerChildListItem}>How it works</li>
              </Link>
            </ul>
          ) : (
            <ul className={styles.footerChild}>
              <li className={styles.footerChildHeader}>Connections</li>
              {props.connectionList
                ?.sort((a, b) => {
                  const aFriends = a.numFriends;
                  const bFriends = b.numFriends;

                  if (aFriends && bFriends) {
                    return bFriends - aFriends;
                  } else if (aFriends) {
                    return -1;
                  } else if (bFriends) {
                    return 1;
                  } else {
                    return 0;
                  }
                })
                .slice(0, 10)
                .map((profile) => {
                  return (
                    <Link href={`/${profile.userName}`} key={profile.ownerUUID}>
                      <li className={styles.footerChildListItem}>
                        {profile.name ?? `@${profile.userName}`}
                      </li>
                    </Link>
                  );
                })}
            </ul>
          )}
          <ul className={styles.footerChild}>
            <Link href={"/dimensions"}>
              <li className={styles.footerChildHeader}>Dimensions</li>
            </Link>
            <Link href={"/dimensions/primary-traits"}>
              <li className={styles.footerChildListItem}>Primary Traits</li>
            </Link>
            <Link href={"/dimensions/cognition"}>
              <li className={styles.footerChildListItem}>Cognition</li>
            </Link>
            <Link href={"/dimensions/values"}>
              <li className={styles.footerChildListItem}>Values</li>
            </Link>
            <Link href={"/dimensions/love-style"}>
              <li className={styles.footerChildListItem}>Love Styles</li>
            </Link>
            <Link href={"/dimensions/attachment-style"}>
              <li className={styles.footerChildListItem}>Attachment Style</li>
            </Link>
            <Link href={"/dimensions/love-attitudes"}>
              <li className={styles.footerChildListItem}>Love Attitudes</li>
            </Link>
            <Link href={"/dimensions/strengths"}>
              <li className={styles.footerChildListItem}>Strengths</li>
            </Link>
            <Link href={"/dimensions/conflict-style"}>
              <li className={styles.footerChildListItem}>Conflict Styles</li>
            </Link>
            <Link href={"/dimensions/work-style"}>
              <li className={styles.footerChildListItem}>Interaction Styles</li>
            </Link>
            <Link href={"/dimensions/interests"}>
              <li className={styles.footerChildListItem}>Interests</li>
            </Link>
          </ul>
          <ul className={styles.footerChild}>
            <Link href={"/archetype-group"}>
              <li className={styles.footerChildHeader}>Archetypes</li>
            </Link>
            <Link href={"/archetype-group/personality-II"}>
              <li className={styles.footerChildListItem}>
                Identity Archetypes
              </li>
            </Link>
            <Link href={"/archetype-group/love-style"}>
              <li className={styles.footerChildListItem}>Love Archetypes</li>
            </Link>
            {/* <Link href={"/archetype-group/values"}>
              <li className={styles.footerChildListItem}>Values Archetypes</li>
            </Link> */}
            <Link href={"/archetype-group/career"}>
              <li className={styles.footerChildListItem}>Career Archetypes</li>
            </Link>
            <Link href={"/archetype-group/work"}>
              <li className={styles.footerChildListItem}>Work Archetypes</li>
            </Link>
          </ul>
          <ul className={styles.footerChild}>
            <Link href={"/natures"}>
              <li className={styles.footerChildHeader}>Natures</li>
            </Link>
            <Link href={"/natures/opennessAndIntellect"}>
              <li className={styles.footerChildListItem}>
                Openness & Curiosity
              </li>
            </Link>
            <Link href={"/natures/chaos"}>
              <li className={styles.footerChildListItem}>
                Passion & Sensitivity
              </li>
            </Link>
            <Link href={"/natures/energyAndExcitement"}>
              <li className={styles.footerChildListItem}>
                Energy & Excitement
              </li>
            </Link>
            <Link href={"/natures/warmthAndAgreeableness"}>
              <li className={styles.footerChildListItem}>
                Warmth & Agreeableness
              </li>
            </Link>
            <Link href={"/natures/orderAndStructure"}>
              <li className={styles.footerChildListItem}>
                Order & Responsibility
              </li>
            </Link>
            <Link href={"/natures/tranquility"}>
              <li className={styles.footerChildListItem}>Tranquility</li>
            </Link>
            <Link href={"/natures/selfEnhancement"}>
              <li className={styles.footerChildListItem}>
                Ambition & Self-Enhancement
              </li>
            </Link>
          </ul>
          <ul className={styles.footerChild}>
            <Link href={"https://about.dimensional.me/faqs"}>
              <li className={styles.footerChildHeader}>FAQs</li>
            </Link>
            <li className={styles.footerChildListItem}>What is Dimensional?</li>
            <li className={styles.footerChildListItem}>
              Does Personality Testing work?
            </li>
          </ul>
        </div>
      </footer>
      {/* <PublicFooter /> */}
    </>
  );
}
